// removed by extract-text-webpack-plugin
module.exports = {"placeholder":"_-src-components-RuleNameClickToEdit-styles---placeholder---VhAuW","form":"_-src-components-RuleNameClickToEdit-styles---form---1ceIO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RuleNameClickToEdit/styles.css
// module id = 823
// module chunks = 0